// // import React from "react";
// // import {
// //   ChevronRight,
// //   Bell,
// //   MessageCircle,
// //   Calendar,
// //   Shield,
// //   ChartColumn,
// //   Users,
// //   TrendingUp,
// //   Zap,
// //   GitMerge,
// //   Settings,
// //   CheckCircle2,
// //   Clock,
// //   FileText,
// //   UserCheck,
// //   Rocket,
// //   Heart,
// //   FileCheck,
// //   Timer,
// //   Award,
// //   Briefcase,
// //   DollarSign,
// //   HomeIcon,
// // } from "lucide-react";
// // import { Helmet } from "react-helmet-async";
// // import InsuranceImage from "../../assets/insurance.jpeg";
// // const Insurance = () => {
// //   const leadManagementFeatures = [
// //     {
// //       title: "Intelligent Lead Capture & Scoring",
// //       content:
// //         "Automatically capture insurance inquiries from multiple sources—website forms, comparison sites, social media ads, and call centers. Our AI-powered lead scoring system evaluates leads based on policy type, coverage amount, premium budget, age, health status, and engagement behavior. Instantly identify high-intent buyers for life, health, auto, or property insurance.",
// //       icon: Users,
// //     },
// //     {
// //       title: "Automated Lead Nurturing",
// //       content:
// //         "Set up intelligent SMS, email, and WhatsApp sequences that nurture insurance leads automatically. From welcome messages to policy recommendations, premium reminders, and renewal alerts. Our system tracks open rates, click-throughs, and engagement in real-time, ensuring no prospect falls through the cracks.",
// //       icon: MessageCircle,
// //     },
// //     {
// //       title: "Policy Quote Automation",
// //       content:
// //         "Instantly generate and send policy quotes via SMS or email when leads show interest. Our system calculates premiums based on lead information and delivers personalized quotes automatically. Track which quotes are opened, shared, and converted to active policies.",
// //       icon: FileText,
// //     },
// //     {
// //       title: "Renewal & Payment Management",
// //       content:
// //         "Reduce policy lapse rates by 60% with automated renewal reminders and payment notifications. Schedule premium due alerts, send payment links via SMS, and follow up automatically after payments. Complete visibility into renewal pipeline and collection rates.",
// //       icon: Calendar,
// //     },
// //     {
// //       title: "Lead Distribution & Agent Assignment",
// //       content:
// //         "Automatically assign insurance leads to the right agents based on policy type, location, expertise, or agent availability. Smart routing ensures faster response times and higher conversion rates. Track agent performance, response times, and policy closure rates with detailed analytics.",
// //       icon: GitMerge,
// //     },
// //     {
// //       title: "Claims Management Integration",
// //       content:
// //         "Streamline claims processing with automated notifications and updates. Send claim status alerts, document requests, and settlement confirmations via SMS. Keep policyholders informed throughout the claims journey and improve customer satisfaction.",
// //       icon: Shield,
// //     },
// //   ];

// //   const lmsWorkflows = [
// //     {
// //       icon: UserCheck,
// //       title: "Lead Capture",
// //       steps: [
// //         "Website Forms",
// //         "Comparison Sites",
// //         "Social Media Ads",
// //         "Call Center Leads",
// //         "Referral Programs",
// //       ],
// //     },
// //     {
// //       icon: Zap,
// //       title: "Automated Nurturing",
// //       steps: [
// //         "Welcome Message",
// //         "Policy Recommendations",
// //         "Quote Generation",
// //         "Follow-up Sequences",
// //         "Educational Content",
// //       ],
// //     },
// //     {
// //       icon: Timer,
// //       title: "Quote & Application",
// //       steps: [
// //         "Quote Delivery",
// //         "Document Collection",
// //         "Medical Check-ups",
// //         "Underwriting",
// //         "Policy Issuance",
// //       ],
// //     },
// //     {
// //       icon: Rocket,
// //       title: "Conversion & Renewal",
// //       steps: [
// //         "Payment Collection",
// //         "Policy Activation",
// //         "Welcome Kit",
// //         "Renewal Reminders",
// //         "Cross-sell Opportunities",
// //       ],
// //     },
// //   ];

// //   const lmsBenefits = [
// //     {
// //       icon: Clock,
// //       title: "80% Faster Response",
// //       desc: "Instant lead assignment ensures immediate follow-up",
// //     },
// //     {
// //       icon: TrendingUp,
// //       title: "4x Higher Conversion",
// //       desc: "AI-powered scoring prioritizes high-intent prospects",
// //     },
// //     {
// //       icon: DollarSign,
// //       title: "30% Lower Acquisition Cost",
// //       desc: "Optimized lead nurturing reduces wasted spend",
// //     },
// //     {
// //       icon: Award,
// //       title: "65% Renewal Rate",
// //       desc: "Automated reminders keep policies active",
// //     },
// //   ];
// //   const insuranceTypes = [
// //     {
// //       icon: Heart,
// //       title: "Life Insurance",
// //       desc: "Term plans, ULIPs, whole life, retirement",
// //     },
// //     {
// //       icon: Shield,
// //       title: "Health Insurance",
// //       desc: "Individual, family floater, critical illness",
// //     },
// //     {
// //       icon: Heart,
// //       title: "Auto Insurance",
// //       desc: "Comprehensive, third-party, zero dep",
// //     },
// //     {
// //       icon: Briefcase,
// //       title: "Commercial Insurance",
// //       desc: "Property, liability, workers' comp",
// //     },
// //     {
// //       icon: HomeIcon,
// //       title: "Home Insurance",
// //       desc: "Structure, content, natural disaster",
// //     },
// //     {
// //       icon: HomeIcon,
// //       title: "Travel Insurance",
// //       desc: "Domestic, international, trip cancellation",
// //     },
// //   ];

// //   const coreFeatures = [
// //     {
// //       icon: Bell,
// //       title: "Instant Quote Alerts",
// //       desc: "Deliver personalized quotes instantly with 95% open rate SMS",
// //     },
// //     {
// //       icon: MessageCircle,
// //       title: "Automated Follow-ups",
// //       desc: "Never miss a lead with smart nurturing sequences",
// //     },
// //     {
// //       icon: Calendar,
// //       title: "Renewal Management",
// //       desc: "Reduce policy lapse with automated reminders",
// //     },
// //     {
// //       icon: FileCheck,
// //       title: "Document Collection",
// //       desc: "Streamlined KYC and document verification",
// //     },
// //     {
// //       icon: Shield,
// //       title: "Claims Tracking",
// //       desc: "Real-time claims status updates via SMS",
// //     },
// //     {
// //       icon: ChartColumn,
// //       title: "Analytics Dashboard",
// //       desc: "Track performance, conversions, and ROI",
// //     },
// //   ];

// //   const scrollItems = [
// //     "📱 Website Inquiry",
// //     "📋 Policy Type Selected",
// //     "💰 Premium Quote",
// //     "📞 Agent Assigned",
// //     "📄 Document Upload",
// //     "✅ Underwriting Complete",
// //     "💳 Payment Link Sent",
// //     "🎉 Policy Activated",
// //   ];

// //   const scrollItems2 = [
// //     "📊 Lead Scored - High Intent",
// //     "🎯 Quote Opened",
// //     "📝 Medical Check-up",
// //     "🏦 EMI Option Shared",
// //     "📜 Policy Document Sent",
// //     "🎁 Cross-sell Offer",
// //     "⭐ Review Request",
// //     "🔄 Renewal Reminder",
// //   ];

// //   return (
// //     <>
// //       <Helmet>
// //         {/* Basic SEO */}
// //         <title>Insurance Lead Management System | LMSBots</title>
// //         <meta
// //           name="description"
// //           content="AI-powered insurance lead management system to capture, nurture, and convert leads. Automate quotes, renewals, claims, and increase policy conversions."
// //         />
// //         <meta
// //           name="keywords"
// //           content="insurance CRM, insurance lead management, policy automation, insurance software, lead nurturing insurance, LMSBots"
// //         />

// //         {/* Canonical URL */}
// //         <link rel="canonical" href="https://lmsbots.com/solutions/insurance" />

// //         {/* Open Graph (Facebook / LinkedIn) */}
// //         <meta
// //           property="og:title"
// //           content="Insurance Lead Management System | LMSBots"
// //         />
// //         <meta
// //           property="og:description"
// //           content="Convert insurance leads into loyal policyholders with AI automation. Manage quotes, renewals, and claims in one platform."
// //         />
// //         <meta
// //           property="og:url"
// //           content="https://lmsbots.com/solutions/insurance"
// //         />
// //         <meta property="og:type" content="website" />
// //         <meta
// //           property="og:image"
// //           content="https://lmsbots.com/og-insurance.jpg"
// //         />

// //         {/* Twitter SEO */}
// //         <meta name="twitter:card" content="summary_large_image" />
// //         <meta
// //           name="twitter:title"
// //           content="Insurance Lead Management System | LMSBots"
// //         />
// //         <meta
// //           name="twitter:description"
// //           content="AI-powered CRM for insurance companies to boost conversions and automate workflows."
// //         />
// //         <meta
// //           name="twitter:image"
// //           content="https://lmsbots.com/og-insurance.jpg"
// //         />

// //         {/* Structured Data (VERY IMPORTANT FOR SEO 🚀) */}
// //         <script type="application/ld+json">
// //           {JSON.stringify({
// //             "@context": "https://schema.org",
// //             "@type": "SoftwareApplication",
// //             name: "LMSBots Insurance Lead Management System",
// //             url: "https://lmsbots.com/solutions/insurance",
// //             applicationCategory: "BusinessApplication",
// //             operatingSystem: "Web",
// //             description:
// //               "Insurance lead management system to automate lead capture, nurturing, policy quotes, renewals, and claims.",
// //             provider: {
// //               "@type": "Organization",
// //               name: "LMSBots",
// //             },
// //           })}
// //         </script>
// //       </Helmet>
// //       <main className="font-sans antialiased overflow-x-hidden">
// //         <div className="w-full overflow-hidden">
// //           <style>{`
// //           @keyframes scroll-left {
// //             0% { transform: translateX(0); }
// //             100% { transform: translateX(-50%); }
// //           }
// //           @keyframes scroll-right {
// //             0% { transform: translateX(-50%); }
// //             100% { transform: translateX(0); }
// //           }
// //           .animate-scroll-left {
// //             display: flex;
// //             width: max-content;
// //             animation: scroll-left 40s linear infinite;
// //           }
// //           .animate-scroll-right {
// //             display: flex;
// //             width: max-content;
// //             animation: scroll-right 40s linear infinite;
// //           }
// //           .pause-on-hover:hover {
// //             animation-play-state: paused;
// //           }
// //         `}</style>

// //           {/* HERO SECTION */}
// //           <section className="bg-gradient-to-br from-white via-indigo-50 to-purple-50 py-20 md:py-24 lg:py-28">
// //             <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 flex flex-col-reverse md:flex-row items-center gap-12 md:gap-16 lg:gap-20">
// //               {/* LEFT CONTENT */}
// //               <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left">
// //                 {/* BADGE */}
// //                 <div className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-100 rounded-full border border-indigo-200 mb-6">
// //                   <Zap className="w-4 h-4 text-indigo-600" />
// //                   <span className="text-xs font-semibold text-indigo-600">
// //                     Lead Management System for Insurance
// //                   </span>
// //                 </div>

// //                 {/* HEADING */}
// //                 <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 leading-tight tracking-tight mb-6 max-w-xl">
// //                   Turn Every Insurance Lead into a{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     Loyal Policyholder
// //                   </span>
// //                 </h1>

// //                 {/* DESCRIPTION */}
// //                 <p className="text-base md:text-lg text-slate-700 leading-relaxed max-w-lg mb-2">
// //                   Capture, track, and convert insurance leads with AI-powered
// //                   automation. From first inquiry to policy renewal—manage your
// //                   entire sales pipeline in one intelligent platform.
// //                 </p>
// //               </div>

// //               {/* RIGHT IMAGE */}
// //               <div className="w-full md:w-1/2 flex justify-center md:justify-end">
// //                 <img
// //                   src={InsuranceImage}
// //                   alt="Insurance Lead Management Dashboard"
// //                   className="w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl object-contain rounded "
// //                 />
// //               </div>
// //             </div>
// //           </section>
// //           {/* LEAD MANAGEMENT FEATURES SECTION */}

// //           <section className="bg-gradient-to-br from-white via-indigo-50 to-purple-50 py-20 md:py-24 lg:py-28">
// //             <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
// //               {/* HEADER */}
// //               <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16 lg:mb-20">
// //                 {/* BADGE */}
// //                 <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-50 rounded-full border border-purple-100 mb-6">
// //                   <Settings className="w-4 h-4 text-purple-600" />
// //                   <span className="text-xs font-semibold text-purple-600">
// //                     Complete Lead Management Solution
// //                   </span>
// //                 </div>

// //                 {/* HEADING */}
// //                 <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 leading-tight tracking-tight mb-4">
// //                   How LMSBots Helps{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     Insurance Companies
// //                   </span>
// //                 </h2>

// //                 {/* SUBTEXT */}
// //                 <p className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">
// //                   Everything you need to capture, nurture, and convert insurance
// //                   leads— all in one intelligent platform.
// //                 </p>
// //               </div>

// //               {/* GRID */}
// //               <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-10">
// //                 {leadManagementFeatures.map((feature, idx) => {
// //                   const Icon = feature.icon;
// //                   return (
// //                     <div
// //                       key={idx}
// //                       className="bg-white rounded-2xl p-6 md:p-7 shadow-md border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
// //                     >
// //                       <div className="flex items-start gap-4">
// //                         {/* ICON */}
// //                         <div className="bg-gradient-to-br from-indigo-50 to-purple-50 p-3 rounded-xl shrink-0">
// //                           <Icon className="w-6 h-6 text-indigo-600" />
// //                         </div>

// //                         {/* CONTENT */}
// //                         <div>
// //                           <h3 className="text-lg md:text-xl font-semibold text-slate-900 mb-2">
// //                             {feature.title}
// //                           </h3>
// //                           <p className="text-slate-600 text-sm md:text-base leading-relaxed">
// //                             {feature.content}
// //                           </p>
// //                         </div>
// //                       </div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>
// //           </section>
// //           {/* INSURANCE TYPES SECTION */}
// //           <section className="py-20 bg-white relative -mt-16">
// //             <div className="container mx-auto px-6 lg:px-12">
// //               <div className="text-center max-w-3xl mx-auto mb-16">
// //                 <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wider mb-4 block">
// //                   Insurance Products
// //                 </span>
// //                 <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
// //                   Manage Leads Across{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     All Insurance Types
// //                   </span>
// //                 </h2>
// //                 <p className="text-xl text-slate-600">
// //                   Specialized workflows for every insurance product
// //                 </p>
// //               </div>

// //               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
// //                 {insuranceTypes.map((type, idx) => {
// //                   const Icon = type.icon;
// //                   return (
// //                     <div
// //                       key={idx}
// //                       className="group bg-gradient-to-br from-slate-50 to-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all border border-slate-100"
// //                     >
// //                       <div className="bg-indigo-100 w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:bg-indigo-600 transition-colors">
// //                         <Icon className="w-7 h-7 text-indigo-600 group-hover:text-white transition-colors" />
// //                       </div>
// //                       <h3 className="text-xl font-bold text-slate-900 mb-2">
// //                         {type.title}
// //                       </h3>
// //                       <p className="text-slate-600 text-sm">{type.desc}</p>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>
// //           </section>

// //           {/* LMS WORKFLOW SECTION */}
// //           <section className="py-20 bg-gradient-to-r from-indigo-50 to-purple-50">
// //             <div className="container mx-auto px-6 lg:px-12">
// //               <div className="text-center max-w-3xl mx-auto mb-16">
// //                 <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wider mb-4 block">
// //                   Lead Management Workflow
// //                 </span>
// //                 <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
// //                   From{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     Lead to Policyholder
// //                   </span>{" "}
// //                   in 4 Simple Steps
// //                 </h2>
// //                 <p className="text-xl text-slate-600">
// //                   Automated workflows that guide prospects through your
// //                   insurance sales pipeline
// //                 </p>
// //               </div>

// //               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
// //                 {lmsWorkflows.map((workflow, idx) => {
// //                   const Icon = workflow.icon;
// //                   return (
// //                     <div key={idx} className="relative group">
// //                       <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all border border-slate-100">
// //                         <div className="bg-indigo-100 w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:bg-indigo-600 transition-colors">
// //                           <Icon className="w-7 h-7 text-indigo-600 group-hover:text-white transition-colors" />
// //                         </div>
// //                         <h3 className="text-xl font-bold text-slate-900 mb-4">
// //                           {workflow.title}
// //                         </h3>
// //                         <ul className="space-y-2">
// //                           {workflow.steps.map((step, i) => (
// //                             <li
// //                               key={i}
// //                               className="flex items-center gap-2 text-slate-600"
// //                             >
// //                               <CheckCircle2 className="w-4 h-4 text-indigo-500" />
// //                               <span className="text-sm">{step}</span>
// //                             </li>
// //                           ))}
// //                         </ul>
// //                       </div>
// //                       {idx < lmsWorkflows.length - 1 && (
// //                         <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2">
// //                           <ChevronRight className="w-6 h-6 text-indigo-300" />
// //                         </div>
// //                       )}
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>
// //           </section>

// //           {/* BENEFITS SECTION */}
// //           <section className="py-20 bg-white">
// //             <div className="container mx-auto px-6 lg:px-12">
// //               <div className="grid lg:grid-cols-2 gap-12 items-center">
// //                 <div className="order-2 lg:order-1">
// //                   <div className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-50 rounded-full border border-indigo-200 mb-6">
// //                     <TrendingUp className="w-4 h-4 text-indigo-600" />
// //                     <span className="text-xs font-semibold text-indigo-600">
// //                       Key Benefits
// //                     </span>
// //                   </div>
// //                   <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
// //                     Why Insurance Companies{" "}
// //                     <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                       Choose LMSBots
// //                     </span>
// //                   </h2>
// //                   <p className="text-lg text-slate-600 mb-8">
// //                     Our lead management system helps you close more policies
// //                     faster with intelligent automation and real-time insights
// //                   </p>
// //                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
// //                     {lmsBenefits.map((benefit, idx) => {
// //                       const Icon = benefit.icon;
// //                       return (
// //                         <div
// //                           key={idx}
// //                           className="bg-gradient-to-br from-slate-50 to-white rounded-xl p-4 shadow-sm border border-slate-100"
// //                         >
// //                           <Icon className="w-8 h-8 text-indigo-600 mb-2" />
// //                           <h4 className="font-bold text-slate-900 mb-1">
// //                             {benefit.title}
// //                           </h4>
// //                           <p className="text-sm text-slate-600">
// //                             {benefit.desc}
// //                           </p>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                 </div>
// //                 <div className="order-1 lg:order-2 relative">
// //                   <div className="absolute -inset-4 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-3xl opacity-20 blur-2xl"></div>
// //                   <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden">
// //                     <img
// //                       src="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
// //                       alt="Insurance Analytics Dashboard"
// //                       className="w-full h-auto object-cover"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </section>

// //           {/* CORE FEATURES SECTION */}
// //           <section className="py-20 bg-gradient-to-r from-indigo-50 to-purple-50">
// //             <div className="container mx-auto px-6 lg:px-12">
// //               <div className="text-center max-w-3xl mx-auto mb-16">
// //                 <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
// //                   Powerful Features for{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     Insurance Success
// //                   </span>
// //                 </h2>
// //                 <p className="text-xl text-slate-600">
// //                   Everything you need to streamline lead management and close
// //                   more policies
// //                 </p>
// //               </div>
// //               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
// //                 {coreFeatures.map((feature, idx) => {
// //                   const Icon = feature.icon;
// //                   return (
// //                     <div
// //                       key={idx}
// //                       className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-slate-100"
// //                     >
// //                       <div className="relative mb-6">
// //                         <div className="absolute inset-0 bg-indigo-600 rounded-2xl opacity-10 group-hover:opacity-20 transition-opacity duration-300 transform -rotate-6 group-hover:rotate-0"></div>
// //                         <div className="relative transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3">
// //                           <Icon className="w-8 h-8 text-indigo-600" />
// //                         </div>
// //                       </div>
// //                       <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-indigo-600 transition-colors duration-300">
// //                         {feature.title}
// //                       </h3>
// //                       <p className="text-slate-600 leading-relaxed mb-4">
// //                         {feature.desc}
// //                       </p>
// //                       <div className="absolute bottom-0 left-0 w-0 h-1 bg-indigo-600 group-hover:w-full transition-all duration-300 rounded-b-2xl"></div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>
// //           </section>

// //           {/* SCROLLING LEAD JOURNEY SECTION */}
// //           <section className="bg-white py-20 lg:py-20">
// //             <div className="container mx-auto px-6 lg:px-12 text-center">
// //               <h2 className="text-4xl lg:text-6xl font-bold text-slate-900 mb-6 tracking-tight">
// //                 The Complete{" "}
// //                 <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                   Insurance Lead Journey
// //                 </span>
// //               </h2>
// //               <p className="text-xl text-slate-500 max-w-2xl mx-auto mb-12">
// //                 See how leads move through your automated sales pipeline—from
// //                 first inquiry to policy activation
// //               </p>
// //               <div className="relative mt-20 mb-20 overflow-hidden">
// //                 <div className="absolute inset-y-0 left-0 w-40 z-10 bg-gradient-to-r from-white to-transparent"></div>
// //                 <div className="absolute inset-y-0 right-0 w-40 z-10 bg-gradient-to-l from-white to-transparent"></div>
// //                 <div className="animate-scroll-left gap-8 mb-8">
// //                   {scrollItems.map((item, i) => (
// //                     <div
// //                       key={i}
// //                       className="px-7 py-4 bg-indigo-50 border border-indigo-100 rounded-3xl text-slate-700 font-semibold text-lg whitespace-nowrap transition-all shadow-sm mx-4 cursor-default"
// //                     >
// //                       {item}
// //                     </div>
// //                   ))}
// //                 </div>
// //                 <div className="animate-scroll-right gap-8">
// //                   {scrollItems2.map((item, i) => (
// //                     <div
// //                       key={i}
// //                       className="px-7 py-4 bg-indigo-50 border border-indigo-100 rounded-3xl text-slate-700 font-semibold text-lg whitespace-nowrap transition-all shadow-sm mx-4 cursor-default"
// //                     >
// //                       {item}
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //               <p className="text-lg lg:text-xl text-slate-600 font-normal max-w-4xl mx-auto leading-relaxed mb-16">
// //                 Automate your entire insurance sales pipeline—from lead capture
// //                 and scoring to quoting, underwriting, and renewal. Get complete
// //                 visibility into every stage and watch your conversion rates
// //                 soar.
// //               </p>
// //             </div>
// //           </section>
// //         </div>
// //       </main>
// //     </>
// //   );
// // };

// // export default Insurance;







// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { motion, useReducedMotion } from "framer-motion";
// import {
//   ArrowRight,
//   Bell,
//   MessageCircle,
//   Calendar,
//   Shield,
//   BarChart3,
//   Users,
//   TrendingUp,
//   Zap,
//   Settings,
//   CheckCircle2,
//   Clock,
//   FileText,
//   FileCheck,
//   UserCheck,
//   Rocket,
//   GitMerge,
//   Heart,
//   HeartPulse,
//   Car,
//   Briefcase,
//   Home,
//   Plane,
//   Timer,
//   Target,
//   Lock,
//   ChevronDown,
//   Smartphone,
//   ClipboardList,
//   Wallet,
//   Phone,
//   CreditCard,
//   Eye,
//   Stethoscope,
//   Gift,
//   Star,
//   RefreshCw,
//   Search,
//   Building2,
// } from "lucide-react";
// import InsuranceImage from "../../assets/insurance.jpeg";
// // NOTE: adjust this path to wherever Seo.js lives in your project
// import Seo, { SITE_URL } from "../../WebsiteComponents/Seo";

// const PATH = "/solutions/insurance";
// const TITLE = "Insurance Lead Management System & CRM | LMSBOTS";
// const DESCRIPTION =
//   "LMSBOTS insurance CRM helps insurers, brokers and agencies capture leads, score and route them to agents, automate quotes, renewals and claim updates, and convert more policies.";

// // ---------- Static content (outside the component so it isn't rebuilt on every render) ----------
// const HERO_POINTS = ["Lead scoring", "Instant quotes", "Renewal reminders"];

// const FEATURE_TABS = [
//   { id: "all", label: "All Features", icon: Zap },
//   { id: "lead", label: "Lead Capture", icon: Users },
//   { id: "nurturing", label: "Nurturing", icon: MessageCircle },
//   { id: "quote", label: "Policy Quotes", icon: FileText },
//   { id: "renewal", label: "Renewals", icon: Calendar },
//   { id: "distribution", label: "Agent Assignment", icon: GitMerge },
//   { id: "claims", label: "Claims Updates", icon: Shield },
// ];

// const LEAD_FEATURES = [
//   {
//     title: "Intelligent Lead Capture & Scoring",
//     content:
//       "Capture insurance inquiries from website forms, comparison sites, social media ads, and call centers. Scoring weighs policy type, coverage amount, premium budget, age, and engagement so your agents can spot high-intent buyers for life, health, motor, or property cover first.",
//     icon: Users,
//     category: "lead",
//   },
//   {
//     title: "Automated Lead Nurturing",
//     content:
//       "Run SMS, email, and WhatsApp sequences that welcome new leads, recommend policies, and send premium and renewal alerts. Track opens, clicks, and replies so no prospect slips through the cracks.",
//     icon: MessageCircle,
//     category: "nurturing",
//   },
//   {
//     title: "Policy Quote Automation",
//     content:
//       "Send policy quotes by SMS or email the moment a lead shows interest, using premium rules you define. See which quotes were opened, shared, and converted into active policies.",
//     icon: FileText,
//     category: "quote",
//   },
//   {
//     title: "Renewal & Payment Management",
//     content:
//       "Cut policy lapses with automated renewal reminders and premium-due alerts. Send payment links by SMS, follow up after payments, and keep a clear view of your renewal pipeline and collections.",
//     icon: Calendar,
//     category: "renewal",
//   },
//   {
//     title: "Lead Distribution & Agent Assignment",
//     content:
//       "Route leads to the right agent by policy type, location, expertise, or availability. Faster first response, plus dashboards for agent response times and policy closure rates.",
//     icon: GitMerge,
//     category: "distribution",
//   },
//   {
//     title: "Claims Status Notifications",
//     content:
//       "Keep policyholders informed with claim status alerts, document requests, and settlement confirmations by SMS, email, or WhatsApp, while claim decisions stay in your claims system.",
//     icon: Shield,
//     category: "claims",
//   },
// ];

// const INSURANCE_TYPES = [
//   { icon: Heart, title: "Life Insurance", desc: "Term plans, ULIPs, whole life, and retirement" },
//   { icon: HeartPulse, title: "Health Insurance", desc: "Individual, family floater, and critical illness" },
//   { icon: Car, title: "Motor Insurance", desc: "Comprehensive, third-party, and zero depreciation" },
//   { icon: Briefcase, title: "Commercial Insurance", desc: "Property, liability, and workers' compensation" },
//   { icon: Home, title: "Home Insurance", desc: "Structure, contents, and natural disaster cover" },
//   { icon: Plane, title: "Travel Insurance", desc: "Domestic, international, and trip cancellation" },
// ];

// const AUDIENCE = [
//   {
//     icon: Building2,
//     title: "Insurance companies",
//     desc: "Unify direct, partner, and call-center leads, with clear ownership from inquiry to policy.",
//   },
//   {
//     icon: Briefcase,
//     title: "Brokers & web aggregators",
//     desc: "Capture comparison-site and campaign leads and compare quotes faster for each prospect.",
//   },
//   {
//     icon: UserCheck,
//     title: "Agencies & POS agents",
//     desc: "Keep every prospect, follow-up, and renewal date in one place on web and mobile.",
//   },
//   {
//     icon: Smartphone,
//     title: "Insurtech platforms",
//     desc: "Connect app sign-ups to scoring, quote delivery, and automated nurturing journeys.",
//   },
// ];

// const WORKFLOWS = [
//   {
//     icon: UserCheck,
//     title: "Lead Capture",
//     steps: ["Website forms", "Comparison sites", "Social media ads", "Call center leads", "Referral programs"],
//   },
//   {
//     icon: Zap,
//     title: "Automated Nurturing",
//     steps: ["Welcome message", "Policy recommendations", "Quote generation", "Follow-up sequences", "Educational content"],
//   },
//   {
//     icon: Timer,
//     title: "Quote & Application",
//     steps: ["Quote delivery", "Document collection", "Medical check-ups", "Underwriting handoff", "Policy issuance"],
//   },
//   {
//     icon: Rocket,
//     title: "Conversion & Renewal",
//     steps: ["Payment collection", "Policy activation", "Welcome kit", "Renewal reminders", "Cross-sell opportunities"],
//   },
// ];

// const BENEFITS = [
//   {
//     icon: Clock,
//     title: "Faster first response",
//     desc: "Instant lead assignment means the right agent follows up while interest is high.",
//   },
//   {
//     icon: Target,
//     title: "Better prioritization",
//     desc: "Scoring puts high-intent prospects at the top of every agent's list.",
//   },
//   {
//     icon: TrendingUp,
//     title: "Less wasted spend",
//     desc: "See which channels and campaigns bring policy buyers, and invest accordingly.",
//   },
//   {
//     icon: Lock,
//     title: "Fewer lapsed policies",
//     desc: "Automated renewal and premium reminders keep customers on track.",
//   },
// ];

// const CORE_FEATURES = [
//   { icon: Bell, title: "Instant Quote Alerts", desc: "Deliver personalized quotes to leads by SMS, email, or WhatsApp." },
//   { icon: MessageCircle, title: "Automated Follow-ups", desc: "Smart nurturing sequences so no lead goes quiet." },
//   { icon: Calendar, title: "Renewal Management", desc: "Schedule reminders ahead of every premium due date." },
//   { icon: FileCheck, title: "Document Collection", desc: "Collect KYC and application documents through secure links." },
//   { icon: Shield, title: "Claims Tracking", desc: "Share claim status updates with policyholders as they happen." },
//   { icon: BarChart3, title: "Analytics Dashboard", desc: "Track conversions, agent performance, and ROI in real time." },
// ];

// const JOURNEY_1 = [
//   { icon: Search, label: "Website inquiry" },
//   { icon: ClipboardList, label: "Policy type selected" },
//   { icon: Wallet, label: "Premium quote" },
//   { icon: Phone, label: "Agent assigned" },
//   { icon: FileText, label: "Document upload" },
//   { icon: CheckCircle2, label: "Underwriting complete" },
//   { icon: CreditCard, label: "Payment link sent" },
//   { icon: Rocket, label: "Policy activated" },
// ];

// const JOURNEY_2 = [
//   { icon: Target, label: "Lead scored: high intent" },
//   { icon: Eye, label: "Quote opened" },
//   { icon: Stethoscope, label: "Medical check-up" },
//   { icon: CreditCard, label: "EMI option shared" },
//   { icon: FileCheck, label: "Policy document sent" },
//   { icon: Gift, label: "Cross-sell offer" },
//   { icon: Star, label: "Review request" },
//   { icon: RefreshCw, label: "Renewal reminder" },
// ];

// const FAQS = [
//   {
//     q: "What is an insurance lead management system?",
//     a: "An insurance lead management system is software that captures inquiries from every channel, scores them, assigns them to the right agent, automates quotes and follow-ups, and tracks each lead through to policy issuance and renewal.",
//   },
//   {
//     q: "Which lead sources can LMSBOTS capture for insurance?",
//     a: "LMSBOTS captures leads from website forms, comparison and aggregator sites, social media ads, call centers, referral programs, and marketing campaigns, and shows the source of every lead in one dashboard.",
//   },
//   {
//     q: "Can it send policy quotes and renewal reminders automatically?",
//     a: "Yes. You can send quotes by SMS, email, or WhatsApp based on your premium rules, and schedule renewal and premium-due reminders ahead of each due date, with payment links included.",
//   },
//   {
//     q: "Does LMSBOTS replace our policy administration or claims system?",
//     a: "No. LMSBOTS manages the sales and customer-communication side: leads, follow-ups, quotes, renewals, and status notifications. Underwriting, policy issuance, and claim decisions stay in your core systems.",
//   },
//   {
//     q: "Is it suitable for brokers, agencies, and POS agents?",
//     a: "Yes. Brokers, agencies, and POS agents use LMSBOTS to keep prospects, follow-ups, and renewal dates organized, with performance reports per agent or team.",
//   },
//   {
//     q: "How are leads assigned to agents?",
//     a: "Leads can be routed automatically by policy type, location, language, expertise, or availability, and reassigned when an agent is unavailable. Dashboards show response times and closure rates for every agent.",
//   },
// ];

// const JSON_LD = [
//   {
//     "@context": "https://schema.org",
//     "@type": "SoftwareApplication",
//     name: "LMSBOTS Insurance Lead Management System",
//     url: `${SITE_URL}${PATH}`,
//     applicationCategory: "BusinessApplication",
//     applicationSubCategory: "Insurance CRM / Lead Management",
//     operatingSystem: "Web, Android, iOS",
//     description: DESCRIPTION,
//     publisher: { "@id": `${SITE_URL}/#organization` },
//     featureList: LEAD_FEATURES.map((f) => f.title),
//   },
//   {
//     "@context": "https://schema.org",
//     "@type": "FAQPage",
//     mainEntity: FAQS.map(({ q, a }) => ({
//       "@type": "Question",
//       name: q,
//       acceptedAnswer: { "@type": "Answer", text: a },
//     })),
//   },
//   {
//     "@context": "https://schema.org",
//     "@type": "BreadcrumbList",
//     itemListElement: [
//       { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
//       { "@type": "ListItem", position: 2, name: "Solutions", item: `${SITE_URL}/solutions` },
//       { "@type": "ListItem", position: 3, name: "Insurance", item: `${SITE_URL}${PATH}` },
//     ],
//   },
// ];

// const fadeUp = {
//   hidden: { opacity: 0, y: 30 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
// };

// const stagger = {
//   hidden: { opacity: 0 },
//   visible: { opacity: 1, transition: { staggerChildren: 0.12 } },
// };

// // Scrolling-journey animation. Respects reduced motion: becomes a static wrapped list.
// const MARQUEE_CSS = `
// .ins-track{display:flex;width:max-content}
// @keyframes ins-left{from{transform:translateX(0)}to{transform:translateX(-50%)}}
// @keyframes ins-right{from{transform:translateX(-50%)}to{transform:translateX(0)}}
// @media (prefers-reduced-motion: no-preference){
//   .ins-left{animation:ins-left 50s linear infinite}
//   .ins-right{animation:ins-right 50s linear infinite}
//   .ins-pause:hover .ins-track,.ins-pause:focus-within .ins-track{animation-play-state:paused}
// }
// @media (prefers-reduced-motion: reduce){
//   .ins-track{width:auto;flex-wrap:wrap;justify-content:center}
//   .ins-dup{display:none}
// }
// `;

// // ---------- Small shared pieces ----------
// const Pill = ({ icon: Icon, children }) => (
//   <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-medium text-[#48247f] shadow-sm">
//     {Icon ? <Icon className="h-3.5 w-3.5 text-[#702cb0]" /> : <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#12dfbd]" />}
//     {children}
//   </div>
// );

// const SectionHeading = ({ id, pill, icon, before, highlight, after, text }) => (
//   <div className="mx-auto mb-10 max-w-3xl text-center lg:mb-14">
//     <Pill icon={icon}>{pill}</Pill>
//     <h2
//       id={id}
//       className="text-balance text-[26px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[34px] lg:text-[38px]"
//     >
//       {before}{" "}
//       <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
//         {highlight}
//       </span>
//       {after ? ` ${after}` : ""}
//     </h2>
//     {text && (
//       <p className="mx-auto mt-4 max-w-[640px] text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base">{text}</p>
//     )}
//     <div className="mx-auto mt-6 h-1 w-24 rounded-full bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f]" />
//   </div>
// );

// const IconTile = ({ icon: Icon, size = "md" }) => (
//   <div
//     className={`inline-flex flex-shrink-0 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white ${
//       size === "lg" ? "h-14 w-14" : "h-12 w-12"
//     }`}
//   >
//     <Icon className={size === "lg" ? "h-7 w-7" : "h-6 w-6"} />
//   </div>
// );

// const CARD =
//   "group relative overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white shadow-[0_8px_30px_-12px_rgba(72,36,127,0.25)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.4)] motion-reduce:transition-none motion-reduce:hover:translate-y-0";

// const ACCENT_BAR =
//   "absolute left-0 top-0 h-1 w-full origin-left scale-x-0 bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-x-100";

// const JourneyChip = ({ icon: Icon, label, dup = false }) => (
//   <li
//     aria-hidden={dup ? "true" : undefined}
//     className={`${dup ? "ins-dup " : ""}mx-2 inline-flex flex-shrink-0 items-center gap-3 whitespace-nowrap rounded-2xl border border-[#48247f]/10 bg-white px-5 py-3 text-sm font-medium text-[#28194f] shadow-sm sm:text-base`}
//   >
//     <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#f1ecfa] text-[#48247f]">
//       <Icon className="h-4 w-4" />
//     </span>
//     {label}
//   </li>
// );

// const Insurance = () => {
//   const reduced = useReducedMotion();
//   const item = reduced ? undefined : fadeUp;
//   const group = reduced ? undefined : stagger;
//   const initial = reduced ? false : "hidden";

//   const [activeTab, setActiveTab] = useState("all");
//   const filteredFeatures =
//     activeTab === "all" ? LEAD_FEATURES : LEAD_FEATURES.filter((f) => f.category === activeTab);

//   // Arrow-key navigation between tabs (standard tablist behaviour)
//   const onTabKeyDown = (e, index) => {
//     let next = null;
//     if (e.key === "ArrowRight") next = (index + 1) % FEATURE_TABS.length;
//     if (e.key === "ArrowLeft") next = (index - 1 + FEATURE_TABS.length) % FEATURE_TABS.length;
//     if (e.key === "Home") next = 0;
//     if (e.key === "End") next = FEATURE_TABS.length - 1;
//     if (next === null) return;
//     e.preventDefault();
//     setActiveTab(FEATURE_TABS[next].id);
//     document.getElementById(`ins-tab-${FEATURE_TABS[next].id}`)?.focus();
//   };

//   return (
//     <>
//       <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />
//       <style>{MARQUEE_CSS}</style>

//       <main id="main-content" className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased">
//         {/* ================= HERO (mint-to-lavender surface with a dot grid) ================= */}
//         <section
//           id="insurance-hero"
//           aria-labelledby="insurance-heading"
//           className="relative isolate w-full overflow-hidden bg-gradient-to-br from-[#effbf8] via-white to-[#fbf7ff]"
//         >
//           <div
//             className="pointer-events-none absolute inset-0 -z-10 opacity-[0.35]"
//             style={{
//               backgroundImage: "radial-gradient(#48247f22 1px, transparent 1px)",
//               backgroundSize: "22px 22px",
//               WebkitMaskImage: "radial-gradient(ellipse at center, black 30%, transparent 80%)",
//               maskImage: "radial-gradient(ellipse at center, black 30%, transparent 80%)",
//             }}
//           />
//           <div className="pointer-events-none absolute -left-24 -top-24 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
//           <div className="pointer-events-none absolute -bottom-24 -right-24 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />

//           <div className="relative z-10 mx-auto grid w-full max-w-[1500px] items-center gap-10 px-4 pb-14 pt-24 sm:gap-12 sm:px-10 sm:pb-16 sm:pt-28 lg:grid-cols-2 lg:gap-14 lg:px-14 lg:pb-20 lg:pt-32 xl:px-20">
//             <motion.div
//               initial={initial}
//               animate="visible"
//               variants={group}
//               className="mx-auto max-w-xl text-center lg:mx-0 lg:text-left"
//             >
//               <motion.div variants={item}>
//                 <Pill icon={Zap}>Lead Management for Insurance</Pill>
//               </motion.div>

//               <motion.h1
//                 id="insurance-heading"
//                 variants={item}
//                 className="text-balance text-[28px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px] xl:text-[42px]"
//               >
//                 Turn every insurance lead into a{" "}
//                 <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
//                   loyal policyholder
//                 </span>
//               </motion.h1>

//               <motion.p
//                 variants={item}
//                 className="mx-auto mt-4 max-w-[540px] text-sm font-light leading-[1.75] text-[#3b2a63] sm:text-base lg:mx-0 lg:text-[17px]"
//               >
//                 Capture, track, and convert insurance leads with intelligent automation. From first
//                 inquiry to policy renewal, manage your entire sales pipeline on one platform.
//               </motion.p>

//               <motion.div
//                 variants={item}
//                 className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center lg:justify-start lg:gap-4"
//               >
//                 <Link
//                   to="/contact"
//                   className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-6 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] hover:shadow-[#12dfbd]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//                 >
//                   Request a Demo
//                   <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
//                 </Link>
//                 <Link
//                   to="/features"
//                   className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-6 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//                 >
//                   Explore Features
//                 </Link>
//               </motion.div>

//               <motion.ul
//                 variants={item}
//                 className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 lg:justify-start"
//               >
//                 {HERO_POINTS.map((p) => (
//                   <li key={p} className="inline-flex items-center gap-2 text-xs font-medium text-[#3b2a63] sm:text-sm">
//                     <CheckCircle2 className="h-4 w-4 text-[#0f9d86]" strokeWidth={2.5} />
//                     {p}
//                   </li>
//                 ))}
//               </motion.ul>
//             </motion.div>

//             <motion.div
//               initial={reduced ? false : { opacity: 0, x: 40 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.8, ease: "easeOut" }}
//               className="group relative mx-auto w-full max-w-[600px] px-3 pb-6 pt-3 lg:max-w-none"
//             >
//               <div className="absolute inset-x-3 bottom-6 top-3 -translate-x-3 translate-y-3 rounded-3xl bg-gradient-to-br from-[#48247f] to-[#702cb0] transition-transform duration-500 group-hover:-translate-x-4 group-hover:translate-y-4 motion-reduce:transition-none" />
//               <div className="relative rounded-2xl bg-white p-2 shadow-2xl ring-1 ring-[#48247f]/10">
//                 <img
//                   src={InsuranceImage}
//                   alt="LMSBOTS insurance lead management dashboard showing policy leads, quotes and renewals"
//                   width="1200"
//                   height="800"
//                   fetchpriority="high"
//                   decoding="async"
//                   className="h-auto w-full rounded-xl border border-[#48247f]/10 object-cover"
//                 />
//               </div>
//             </motion.div>
//           </div>
//         </section>

//         {/* ================= FEATURES WITH TABS ================= */}
//         <section
//           id="insurance-features"
//           aria-labelledby="insurance-features-heading"
//           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="insurance-features-heading"
//               pill="Complete Lead Management Solution"
//               icon={Settings}
//               before="How LMSBOTS helps"
//               highlight="insurance companies"
//               text="Everything you need to capture, nurture, and convert insurance leads, all in one platform."
//             />

//             <div
//               role="tablist"
//               aria-label="Filter insurance features"
//               className="-mx-4 mb-8 flex gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] sm:mx-0 sm:flex-wrap sm:justify-center sm:overflow-visible sm:px-0 [&::-webkit-scrollbar]:hidden"
//             >
//               {FEATURE_TABS.map((tab, i) => {
//                 const active = activeTab === tab.id;
//                 const Icon = tab.icon;
//                 return (
//                   <button
//                     key={tab.id}
//                     id={`ins-tab-${tab.id}`}
//                     type="button"
//                     role="tab"
//                     aria-selected={active}
//                     aria-controls="ins-panel"
//                     tabIndex={active ? 0 : -1}
//                     onClick={() => setActiveTab(tab.id)}
//                     onKeyDown={(e) => onTabKeyDown(e, i)}
//                     className={`inline-flex min-h-[44px] flex-shrink-0 items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-xs font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#702cb0] focus-visible:ring-offset-2 sm:text-sm ${
//                       active
//                         ? "border-transparent bg-gradient-to-r from-[#48247f] to-[#702cb0] text-white shadow-lg shadow-[#48247f]/25"
//                         : "border-[#48247f]/15 bg-white text-slate-700 hover:border-[#702cb0]/50 hover:text-[#48247f]"
//                     }`}
//                   >
//                     <Icon className="h-4 w-4" />
//                     {tab.label}
//                   </button>
//                 );
//               })}
//             </div>

//             <ul
//               id="ins-panel"
//               role="tabpanel"
//               aria-labelledby={`ins-tab-${activeTab}`}
//               className="grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-8"
//             >
//               {filteredFeatures.map((f) => (
//                 <li key={f.title} className={`${CARD} flex gap-5 p-6 sm:p-8`}>
//                   <div className={ACCENT_BAR} />
//                   <IconTile icon={f.icon} />
//                   <div className="min-w-0">
//                     <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f] sm:text-xl">{f.title}</h3>
//                     <p className="text-sm leading-[1.75] text-slate-700">{f.content}</p>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </section>

//         {/* ================= INSURANCE TYPES ================= */}
//         <section
//           id="insurance-products"
//           aria-labelledby="insurance-products-heading"
//           className="relative isolate w-full overflow-hidden bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
//         >
//           <div className="pointer-events-none absolute -right-24 -top-24 -z-10 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="insurance-products-heading"
//               pill="Insurance Products"
//               before="Manage leads across"
//               highlight="all insurance types"
//               text="Specialized workflows for every insurance product you sell."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8"
//             >
//               {INSURANCE_TYPES.map((t) => (
//                 <motion.li key={t.title} variants={item} className={`${CARD} flex items-center gap-4 p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <IconTile icon={t.icon} size="lg" />
//                   <div className="min-w-0">
//                     <h3 className="text-lg font-medium tracking-tight text-[#28194f]">{t.title}</h3>
//                     <p className="mt-1 text-sm leading-snug text-slate-600">{t.desc}</p>
//                   </div>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= WHO IT'S FOR ================= */}
//         <section
//           id="insurance-audience"
//           aria-labelledby="insurance-audience-heading"
//           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="insurance-audience-heading"
//               pill="Who It's For"
//               icon={Users}
//               before="Built for every"
//               highlight="insurance sales team"
//               text="From large insurers to individual agents, LMSBOTS adapts to how your team finds and keeps policyholders."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
//             >
//               {AUDIENCE.map((a) => (
//                 <motion.li key={a.title} variants={item} className={`${CARD} p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-4">
//                     <IconTile icon={a.icon} />
//                   </div>
//                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{a.title}</h3>
//                   <p className="text-sm leading-[1.7] text-slate-700">{a.desc}</p>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= WORKFLOW ================= */}
//         <section
//           id="insurance-workflow"
//           aria-labelledby="insurance-workflow-heading"
//           className="relative isolate w-full overflow-hidden border-t border-[#48247f]/10 bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
//         >
//           <div className="pointer-events-none absolute -bottom-24 -left-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="insurance-workflow-heading"
//               pill="Lead Management Workflow"
//               icon={RefreshCw}
//               before="From"
//               highlight="lead to policyholder"
//               after="in 4 simple steps"
//               text="Automated workflows that guide prospects through your insurance sales pipeline."
//             />

//             <motion.ol
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 lg:gap-6"
//             >
//               {WORKFLOWS.map((w, i) => (
//                 <motion.li key={w.title} variants={item} className={`${CARD} h-full p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-5 flex items-start justify-between">
//                     <IconTile icon={w.icon} />
//                     <span className="text-3xl font-light leading-none text-[#48247f]/15 transition-colors duration-300 group-hover:text-[#12dfbd]">
//                       {String(i + 1).padStart(2, "0")}
//                     </span>
//                   </div>
//                   <h3 className="mb-4 text-lg font-medium tracking-tight text-[#28194f]">{w.title}</h3>
//                   <ul className="space-y-2.5">
//                     {w.steps.map((s) => (
//                       <li key={s} className="flex items-start gap-2.5 text-sm text-slate-700">
//                         <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#0f9d86]" strokeWidth={2.5} />
//                         <span>{s}</span>
//                       </li>
//                     ))}
//                   </ul>
//                 </motion.li>
//               ))}
//             </motion.ol>
//           </div>
//         </section>

//         {/* ================= BENEFITS ================= */}
//         <section
//           id="insurance-benefits"
//           aria-labelledby="insurance-benefits-heading"
//           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="insurance-benefits-heading"
//               pill="Key Benefits"
//               icon={TrendingUp}
//               before="Why insurance companies choose"
//               highlight="LMSBOTS"
//               text="Close more policies faster with intelligent automation and real-time insight."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
//             >
//               {BENEFITS.map((b) => (
//                 <motion.li key={b.title} variants={item} className={`${CARD} p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-4">
//                     <IconTile icon={b.icon} />
//                   </div>
//                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{b.title}</h3>
//                   <p className="text-sm leading-[1.7] text-slate-700">{b.desc}</p>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= CORE FEATURES ================= */}
//         <section
//           id="insurance-core"
//           aria-labelledby="insurance-core-heading"
//           className="relative isolate w-full overflow-hidden bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
//         >
//           <div className="pointer-events-none absolute -left-24 -top-24 -z-10 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="insurance-core-heading"
//               pill="Core Capabilities"
//               before="Powerful features for"
//               highlight="insurance success"
//               text="Everything you need to streamline lead management and close more policies."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8"
//             >
//               {CORE_FEATURES.map((f) => (
//                 <motion.li key={f.title} variants={item} className={`${CARD} p-6 sm:p-7`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-4">
//                     <IconTile icon={f.icon} />
//                   </div>
//                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{f.title}</h3>
//                   <p className="text-sm leading-[1.7] text-slate-700">{f.desc}</p>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= LEAD JOURNEY ================= */}
//         <section
//           id="insurance-journey"
//           aria-labelledby="insurance-journey-heading"
//           className="relative w-full overflow-hidden bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="insurance-journey-heading"
//               pill="Lead Journey"
//               before="The complete"
//               highlight="insurance lead journey"
//               text="See how leads move through your automated sales pipeline, from first inquiry to policy activation and renewal."
//             />
//           </div>

//           <div className="ins-pause relative space-y-4" role="group" aria-label="Examples of stages in the insurance lead journey">
//             <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-white to-transparent sm:w-32" />
//             <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-white to-transparent sm:w-32" />

//             {[
//               { list: JOURNEY_1, dir: "ins-left" },
//               { list: JOURNEY_2, dir: "ins-right" },
//             ].map(({ list, dir }) => (
//               <div key={dir} className="overflow-hidden">
//                 <ul className={`ins-track ${dir}`}>
//                   {list.map((j) => (
//                     <JourneyChip key={j.label} {...j} />
//                   ))}
//                   {/* Duplicate set makes the loop seamless; hidden from assistive tech and reduced-motion users */}
//                   {list.map((j) => (
//                     <JourneyChip key={`dup-${j.label}`} dup {...j} />
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>

//           <p className="mx-auto mt-10 max-w-3xl px-4 text-center text-[15px] leading-[1.75] text-[#3b2a63] sm:px-10 sm:text-base">
//             Automate your insurance sales pipeline from lead capture and scoring to quoting,
//             application follow-up, and renewal, with complete visibility into every stage.
//           </p>
//         </section>

//         {/* ================= FAQ ================= */}
//         <section
//           id="insurance-faq"
//           aria-labelledby="insurance-faq-heading"
//           className="relative isolate w-full overflow-hidden bg-gradient-to-br from-[#fbf7ff] via-white to-[#effbf8] py-14 sm:py-16 lg:py-24"
//         >
//           <div className="pointer-events-none absolute -bottom-24 -right-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
//           <div className="mx-auto w-full max-w-[900px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="insurance-faq-heading"
//               pill="FAQ"
//               before="Insurance lead management"
//               highlight="questions answered"
//             />

//             <div className="space-y-4">
//               {FAQS.map(({ q, a }, i) => (
//                 <details
//                   key={q}
//                   open={i === 0}
//                   className="group overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white shadow-[0_8px_30px_-14px_rgba(72,36,127,0.25)] transition-colors open:border-[#702cb0]/40"
//                 >
//                   <summary className="flex min-h-[64px] cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#702cb0] sm:px-6 [&::-webkit-details-marker]:hidden">
//                     <h3 className="flex-1 text-[15px] font-medium leading-snug text-[#28194f] sm:text-base">{q}</h3>
//                     <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-open:rotate-180 group-open:bg-[#12dfbd] group-open:text-[#102b37]">
//                       <ChevronDown className="h-5 w-5" />
//                     </span>
//                   </summary>
//                   <p className="px-5 pb-6 text-sm leading-[1.75] text-slate-700 sm:px-6 sm:text-[15px]">{a}</p>
//                 </details>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* ================= CLOSING CTA ================= */}
//         <section
//           aria-labelledby="insurance-cta-heading"
//           className="w-full bg-white px-4 py-10 sm:px-10 sm:py-12 lg:px-14 lg:py-16"
//         >
//           <div className="relative isolate mx-auto w-full max-w-[1300px] overflow-hidden rounded-[1.5rem] border border-[#48247f]/10 bg-gradient-to-br from-[#e3faf5] via-white to-[#f1ecfa] px-5 py-12 text-center shadow-[0_20px_60px_-20px_rgba(72,36,127,0.25)] sm:rounded-[2rem] sm:px-12 sm:py-16">
//             <div className="pointer-events-none absolute -left-20 -top-20 -z-10 h-72 w-72 rounded-full bg-[#702cb0]/10 blur-3xl" />
//             <h2
//               id="insurance-cta-heading"
//               className="mx-auto max-w-2xl text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px]"
//             >
//               Ready to convert{" "}
//               <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
//                 more policies?
//               </span>
//             </h2>
//             <p className="mx-auto mt-4 max-w-[560px] text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base">
//               See how LMSBOTS fits your insurance sales process. In a live demo we'll cover lead
//               capture, quotes, agent assignment, renewals, and reporting.
//             </p>
//             <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
//               <Link
//                 to="/contact"
//                 className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-7 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//               >
//                 Request a Demo
//                 <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
//               </Link>
//               <Link
//                 to="/pricing"
//                 className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-7 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//               >
//                 View Pricing
//               </Link>
//             </div>
//           </div>
//         </section>
//       </main>
//     </>
//   );
// };

// export default Insurance;









import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import {
  ArrowRight,
  Bell,
  MessageCircle,
  Calendar,
  Shield,
  BarChart3,
  Users,
  TrendingUp,
  Zap,
  Settings,
  CheckCircle2,
  Clock,
  FileText,
  FileCheck,
  UserCheck,
  Rocket,
  GitMerge,
  Heart,
  HeartPulse,
  Car,
  Briefcase,
  Home,
  Plane,
  Timer,
  Target,
  Lock,
  ChevronDown,
  Smartphone,
  ClipboardList,
  Wallet,
  Phone,
  CreditCard,
  Eye,
  Stethoscope,
  Gift,
  Star,
  RefreshCw,
  Search,
  Building2,
} from "lucide-react";
import InsuranceImage from "../../assets/insurance.jpeg";
// NOTE: adjust this path to wherever Seo.js lives in your project
import Seo, { SITE_URL } from "../../WebsiteComponents/Seo";
import { ROUTES } from "../../seoData";

const PATH = "/solutions/insurance";
const TITLE = ROUTES[PATH].title;
const DESCRIPTION = ROUTES[PATH].description;

// ---------- Static content (outside the component so it isn't rebuilt on every render) ----------
const HERO_POINTS = ["Lead scoring", "Instant quotes", "Renewal reminders"];

const FEATURE_TABS = [
  { id: "all", label: "All Features", icon: Zap },
  { id: "lead", label: "Lead Capture", icon: Users },
  { id: "nurturing", label: "Nurturing", icon: MessageCircle },
  { id: "quote", label: "Policy Quotes", icon: FileText },
  { id: "renewal", label: "Renewals", icon: Calendar },
  { id: "distribution", label: "Agent Assignment", icon: GitMerge },
  { id: "claims", label: "Claims Updates", icon: Shield },
];

const LEAD_FEATURES = [
  {
    title: "Intelligent Lead Capture & Scoring",
    content:
      "Capture insurance inquiries from website forms, comparison sites, social media ads, and call centers. Scoring weighs policy type, coverage amount, premium budget, age, and engagement so your agents can spot high-intent buyers for life, health, motor, or property cover first.",
    icon: Users,
    category: "lead",
  },
  {
    title: "Automated Lead Nurturing",
    content:
      "Run SMS, email, and WhatsApp sequences that welcome new leads, recommend policies, and send premium and renewal alerts. Track opens, clicks, and replies so no prospect slips through the cracks.",
    icon: MessageCircle,
    category: "nurturing",
  },
  {
    title: "Policy Quote Automation",
    content:
      "Send policy quotes by SMS or email the moment a lead shows interest, using premium rules you define. See which quotes were opened, shared, and converted into active policies.",
    icon: FileText,
    category: "quote",
  },
  {
    title: "Renewal & Payment Management",
    content:
      "Cut policy lapses with automated renewal reminders and premium-due alerts. Send payment links by SMS, follow up after payments, and keep a clear view of your renewal pipeline and collections.",
    icon: Calendar,
    category: "renewal",
  },
  {
    title: "Lead Distribution & Agent Assignment",
    content:
      "Route leads to the right agent by policy type, location, expertise, or availability. Faster first response, plus dashboards for agent response times and policy closure rates.",
    icon: GitMerge,
    category: "distribution",
  },
  {
    title: "Claims Status Notifications",
    content:
      "Keep policyholders informed with claim status alerts, document requests, and settlement confirmations by SMS, email, or WhatsApp, while claim decisions stay in your claims system.",
    icon: Shield,
    category: "claims",
  },
];

const INSURANCE_TYPES = [
  { icon: Heart, title: "Life Insurance", desc: "Term plans, ULIPs, whole life, and retirement" },
  { icon: HeartPulse, title: "Health Insurance", desc: "Individual, family floater, and critical illness" },
  { icon: Car, title: "Motor Insurance", desc: "Comprehensive, third-party, and zero depreciation" },
  { icon: Briefcase, title: "Commercial Insurance", desc: "Property, liability, and workers' compensation" },
  { icon: Home, title: "Home Insurance", desc: "Structure, contents, and natural disaster cover" },
  { icon: Plane, title: "Travel Insurance", desc: "Domestic, international, and trip cancellation" },
];

const AUDIENCE = [
  {
    icon: Building2,
    title: "Insurance companies",
    desc: "Unify direct, partner, and call-center leads, with clear ownership from inquiry to policy.",
  },
  {
    icon: Briefcase,
    title: "Brokers & web aggregators",
    desc: "Capture comparison-site and campaign leads and compare quotes faster for each prospect.",
  },
  {
    icon: UserCheck,
    title: "Agencies & POS agents",
    desc: "Keep every prospect, follow-up, and renewal date in one place on web and mobile.",
  },
  {
    icon: Smartphone,
    title: "Insurtech platforms",
    desc: "Connect app sign-ups to scoring, quote delivery, and automated nurturing journeys.",
  },
];

const WORKFLOWS = [
  {
    icon: UserCheck,
    title: "Lead Capture",
    steps: ["Website forms", "Comparison sites", "Social media ads", "Call center leads", "Referral programs"],
  },
  {
    icon: Zap,
    title: "Automated Nurturing",
    steps: ["Welcome message", "Policy recommendations", "Quote generation", "Follow-up sequences", "Educational content"],
  },
  {
    icon: Timer,
    title: "Quote & Application",
    steps: ["Quote delivery", "Document collection", "Medical check-ups", "Underwriting handoff", "Policy issuance"],
  },
  {
    icon: Rocket,
    title: "Conversion & Renewal",
    steps: ["Payment collection", "Policy activation", "Welcome kit", "Renewal reminders", "Cross-sell opportunities"],
  },
];

const BENEFITS = [
  {
    icon: Clock,
    title: "Faster first response",
    desc: "Instant lead assignment means the right agent follows up while interest is high.",
  },
  {
    icon: Target,
    title: "Better prioritization",
    desc: "Scoring puts high-intent prospects at the top of every agent's list.",
  },
  {
    icon: TrendingUp,
    title: "Less wasted spend",
    desc: "See which channels and campaigns bring policy buyers, and invest accordingly.",
  },
  {
    icon: Lock,
    title: "Fewer lapsed policies",
    desc: "Automated renewal and premium reminders keep customers on track.",
  },
];

const CORE_FEATURES = [
  { icon: Bell, title: "Instant Quote Alerts", desc: "Deliver personalized quotes to leads by SMS, email, or WhatsApp." },
  { icon: MessageCircle, title: "Automated Follow-ups", desc: "Smart nurturing sequences so no lead goes quiet." },
  { icon: Calendar, title: "Renewal Management", desc: "Schedule reminders ahead of every premium due date." },
  { icon: FileCheck, title: "Document Collection", desc: "Collect KYC and application documents through secure links." },
  { icon: Shield, title: "Claims Tracking", desc: "Share claim status updates with policyholders as they happen." },
  { icon: BarChart3, title: "Analytics Dashboard", desc: "Track conversions, agent performance, and ROI in real time." },
];

const JOURNEY_1 = [
  { icon: Search, label: "Website inquiry" },
  { icon: ClipboardList, label: "Policy type selected" },
  { icon: Wallet, label: "Premium quote" },
  { icon: Phone, label: "Agent assigned" },
  { icon: FileText, label: "Document upload" },
  { icon: CheckCircle2, label: "Underwriting complete" },
  { icon: CreditCard, label: "Payment link sent" },
  { icon: Rocket, label: "Policy activated" },
];

const JOURNEY_2 = [
  { icon: Target, label: "Lead scored: high intent" },
  { icon: Eye, label: "Quote opened" },
  { icon: Stethoscope, label: "Medical check-up" },
  { icon: CreditCard, label: "EMI option shared" },
  { icon: FileCheck, label: "Policy document sent" },
  { icon: Gift, label: "Cross-sell offer" },
  { icon: Star, label: "Review request" },
  { icon: RefreshCw, label: "Renewal reminder" },
];

const FAQS = [
  {
    q: "What is an insurance lead management system?",
    a: "An insurance lead management system is software that captures inquiries from every channel, scores them, assigns them to the right agent, automates quotes and follow-ups, and tracks each lead through to policy issuance and renewal.",
  },
  {
    q: "Which lead sources can LMSBOTS capture for insurance?",
    a: "LMSBOTS captures leads from website forms, comparison and aggregator sites, social media ads, call centers, referral programs, and marketing campaigns, and shows the source of every lead in one dashboard.",
  },
  {
    q: "Can it send policy quotes and renewal reminders automatically?",
    a: "Yes. You can send quotes by SMS, email, or WhatsApp based on your premium rules, and schedule renewal and premium-due reminders ahead of each due date, with payment links included.",
  },
  {
    q: "Does LMSBOTS replace our policy administration or claims system?",
    a: "No. LMSBOTS manages the sales and customer-communication side: leads, follow-ups, quotes, renewals, and status notifications. Underwriting, policy issuance, and claim decisions stay in your core systems.",
  },
  {
    q: "Is it suitable for brokers, agencies, and POS agents?",
    a: "Yes. Brokers, agencies, and POS agents use LMSBOTS to keep prospects, follow-ups, and renewal dates organized, with performance reports per agent or team.",
  },
  {
    q: "How are leads assigned to agents?",
    a: "Leads can be routed automatically by policy type, location, language, expertise, or availability, and reassigned when an agent is unavailable. Dashboards show response times and closure rates for every agent.",
  },
];

const JSON_LD = [
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "LMSBOTS Insurance Lead Management System",
    url: `${SITE_URL}${PATH}`,
    applicationCategory: "BusinessApplication",
    applicationSubCategory: "Insurance CRM / Lead Management",
    operatingSystem: "Web, Android, iOS",
    description: DESCRIPTION,
    publisher: { "@id": `${SITE_URL}/#organization` },
    featureList: LEAD_FEATURES.map((f) => f.title),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      { "@type": "ListItem", position: 2, name: "Solutions", item: `${SITE_URL}/solutions` },
      { "@type": "ListItem", position: 3, name: "Insurance", item: `${SITE_URL}${PATH}` },
    ],
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const stagger = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.12 } },
};

// Scrolling-journey animation. Respects reduced motion: becomes a static wrapped list.
const MARQUEE_CSS = `
.ins-track{display:flex;width:max-content}
@keyframes ins-left{from{transform:translateX(0)}to{transform:translateX(-50%)}}
@keyframes ins-right{from{transform:translateX(-50%)}to{transform:translateX(0)}}
@media (prefers-reduced-motion: no-preference){
  .ins-left{animation:ins-left 50s linear infinite}
  .ins-right{animation:ins-right 50s linear infinite}
  .ins-pause:hover .ins-track,.ins-pause:focus-within .ins-track{animation-play-state:paused}
}
@media (prefers-reduced-motion: reduce){
  .ins-track{width:auto;flex-wrap:wrap;justify-content:center}
  .ins-dup{display:none}
}
`;

// ---------- Small shared pieces ----------
const Pill = ({ icon: Icon, children }) => (
  <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-medium text-[#48247f] shadow-sm">
    {Icon ? <Icon className="h-3.5 w-3.5 text-[#702cb0]" /> : <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#12dfbd]" />}
    {children}
  </div>
);

const SectionHeading = ({ id, pill, icon, before, highlight, after, text }) => (
  <div className="mx-auto mb-10 max-w-3xl text-center lg:mb-14">
    <Pill icon={icon}>{pill}</Pill>
    <h2
      id={id}
      className="text-balance text-[26px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[34px] lg:text-[38px]"
    >
      {before}{" "}
      <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
        {highlight}
      </span>
      {after ? ` ${after}` : ""}
    </h2>
    {text && (
      <p className="mx-auto mt-4 max-w-[640px] text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base">{text}</p>
    )}
    <div className="mx-auto mt-6 h-1 w-24 rounded-full bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f]" />
  </div>
);

const IconTile = ({ icon: Icon, size = "md" }) => (
  <div
    className={`inline-flex flex-shrink-0 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white ${
      size === "lg" ? "h-14 w-14" : "h-12 w-12"
    }`}
  >
    <Icon className={size === "lg" ? "h-7 w-7" : "h-6 w-6"} />
  </div>
);

const CARD =
  "group relative overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white shadow-[0_8px_30px_-12px_rgba(72,36,127,0.25)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.4)] motion-reduce:transition-none motion-reduce:hover:translate-y-0";

const ACCENT_BAR =
  "absolute left-0 top-0 h-1 w-full origin-left scale-x-0 bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-x-100";

const JourneyChip = ({ icon: Icon, label, dup = false }) => (
  <li
    aria-hidden={dup ? "true" : undefined}
    className={`${dup ? "ins-dup " : ""}mx-2 inline-flex flex-shrink-0 items-center gap-3 whitespace-nowrap rounded-2xl border border-[#48247f]/10 bg-white px-5 py-3 text-sm font-medium text-[#28194f] shadow-sm sm:text-base`}
  >
    <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#f1ecfa] text-[#48247f]">
      <Icon className="h-4 w-4" />
    </span>
    {label}
  </li>
);

const Insurance = () => {
  const reduced = useReducedMotion();
  const item = reduced ? undefined : fadeUp;
  const group = reduced ? undefined : stagger;
  const initial = reduced ? false : "hidden";

  const [activeTab, setActiveTab] = useState("all");
  const filteredFeatures =
    activeTab === "all" ? LEAD_FEATURES : LEAD_FEATURES.filter((f) => f.category === activeTab);

  // Arrow-key navigation between tabs (standard tablist behaviour)
  const onTabKeyDown = (e, index) => {
    let next = null;
    if (e.key === "ArrowRight") next = (index + 1) % FEATURE_TABS.length;
    if (e.key === "ArrowLeft") next = (index - 1 + FEATURE_TABS.length) % FEATURE_TABS.length;
    if (e.key === "Home") next = 0;
    if (e.key === "End") next = FEATURE_TABS.length - 1;
    if (next === null) return;
    e.preventDefault();
    setActiveTab(FEATURE_TABS[next].id);
    document.getElementById(`ins-tab-${FEATURE_TABS[next].id}`)?.focus();
  };

  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />
      <style>{MARQUEE_CSS}</style>

      <div className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased">
        {/* ================= HERO (mint-to-lavender surface with a dot grid) ================= */}
        <section
          id="insurance-hero"
          aria-labelledby="insurance-heading"
          className="relative isolate w-full overflow-hidden bg-gradient-to-br from-[#effbf8] via-white to-[#fbf7ff]"
        >
          <div
            className="pointer-events-none absolute inset-0 -z-10 opacity-[0.35]"
            style={{
              backgroundImage: "radial-gradient(#48247f22 1px, transparent 1px)",
              backgroundSize: "22px 22px",
              WebkitMaskImage: "radial-gradient(ellipse at center, black 30%, transparent 80%)",
              maskImage: "radial-gradient(ellipse at center, black 30%, transparent 80%)",
            }}
          />
          <div className="pointer-events-none absolute -left-24 -top-24 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -right-24 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />

          <div className="relative z-10 mx-auto grid w-full max-w-[1500px] items-center gap-10 px-4 pb-14 pt-24 sm:gap-12 sm:px-10 sm:pb-16 sm:pt-28 lg:grid-cols-2 lg:gap-14 lg:px-14 lg:pb-20 lg:pt-32 xl:px-20">
            <motion.div
              initial={initial}
              animate="visible"
              variants={group}
              className="mx-auto max-w-xl text-center lg:mx-0 lg:text-left"
            >
              <motion.div variants={item}>
                <Pill icon={Zap}>Lead Management for Insurance</Pill>
              </motion.div>

              <motion.h1
                id="insurance-heading"
                variants={item}
                className="text-balance text-[28px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px] xl:text-[42px]"
              >
                Turn every insurance lead into a{" "}
                <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
                  loyal policyholder
                </span>
              </motion.h1>

              <motion.p
                variants={item}
                className="mx-auto mt-4 max-w-[540px] text-sm font-light leading-[1.75] text-[#3b2a63] sm:text-base lg:mx-0 lg:text-[17px]"
              >
                Capture, track, and convert insurance leads with intelligent automation. From first
                inquiry to policy renewal, manage your entire sales pipeline on one platform.
              </motion.p>

              <motion.div
                variants={item}
                className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center lg:justify-start lg:gap-4"
              >
                <Link
                  to="/contact"
                  className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-6 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] hover:shadow-[#12dfbd]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
                >
                  Request a Demo
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
                <Link
                  to="/features"
                  className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-6 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
                >
                  Explore Features
                </Link>
              </motion.div>

              <motion.ul
                variants={item}
                className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 lg:justify-start"
              >
                {HERO_POINTS.map((p) => (
                  <li key={p} className="inline-flex items-center gap-2 text-xs font-medium text-[#3b2a63] sm:text-sm">
                    <CheckCircle2 className="h-4 w-4 text-[#0f9d86]" strokeWidth={2.5} />
                    {p}
                  </li>
                ))}
              </motion.ul>
            </motion.div>

            {/* Hero image — simple & clean, matching Healthcare */}
            <motion.div
              initial={reduced ? false : { opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="relative mx-auto w-full max-w-[600px] px-3 pb-6 pt-3 lg:max-w-none"
            >
              {/* Plain tinted block sits below the image */}
              <div className="absolute inset-x-8 bottom-0 top-10 rounded-3xl bg-[#e3faf5]" />
              <div className="relative rounded-2xl bg-white p-2 shadow-xl ring-1 ring-slate-200">
                <img
                  src={InsuranceImage}
                  alt="LMSBOTS insurance lead management dashboard showing policy leads, quotes and renewals"
                  width="1200"
                  height="800"
                  fetchpriority="high"
                  decoding="async"
                  className="h-auto w-full rounded-xl border border-slate-200 object-cover"
                />
              </div>
            </motion.div>
          </div>
        </section>

        {/* ================= FEATURES WITH TABS ================= */}
        <section
          id="insurance-features"
          aria-labelledby="insurance-features-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="insurance-features-heading"
              pill="Complete Lead Management Solution"
              icon={Settings}
              before="How LMSBOTS helps"
              highlight="insurance companies"
              text="Everything you need to capture, nurture, and convert insurance leads, all in one platform."
            />

            <div
              role="tablist"
              aria-label="Filter insurance features"
              className="-mx-4 mb-8 flex gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] sm:mx-0 sm:flex-wrap sm:justify-center sm:overflow-visible sm:px-0 [&::-webkit-scrollbar]:hidden"
            >
              {FEATURE_TABS.map((tab, i) => {
                const active = activeTab === tab.id;
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    id={`ins-tab-${tab.id}`}
                    type="button"
                    role="tab"
                    aria-selected={active}
                    aria-controls="ins-panel"
                    tabIndex={active ? 0 : -1}
                    onClick={() => setActiveTab(tab.id)}
                    onKeyDown={(e) => onTabKeyDown(e, i)}
                    className={`inline-flex min-h-[44px] flex-shrink-0 items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-xs font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#702cb0] focus-visible:ring-offset-2 sm:text-sm ${
                      active
                        ? "border-transparent bg-gradient-to-r from-[#48247f] to-[#702cb0] text-white shadow-lg shadow-[#48247f]/25"
                        : "border-[#48247f]/15 bg-white text-slate-700 hover:border-[#702cb0]/50 hover:text-[#48247f]"
                    }`}
                  >
                    <Icon className="h-4 w-4" />
                    {tab.label}
                  </button>
                );
              })}
            </div>

            <ul
              id="ins-panel"
              role="tabpanel"
              aria-labelledby={`ins-tab-${activeTab}`}
              className="grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-8"
            >
              {filteredFeatures.map((f) => (
                <li key={f.title} className={`${CARD} flex gap-5 p-6 sm:p-8`}>
                  <div className={ACCENT_BAR} />
                  <IconTile icon={f.icon} />
                  <div className="min-w-0">
                    <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f] sm:text-xl">{f.title}</h3>
                    <p className="text-sm leading-[1.75] text-slate-700">{f.content}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* ================= INSURANCE TYPES ================= */}
        <section
          id="insurance-products"
          aria-labelledby="insurance-products-heading"
          className="relative isolate w-full overflow-hidden bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
        >
          <div className="pointer-events-none absolute -right-24 -top-24 -z-10 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="insurance-products-heading"
              pill="Insurance Products"
              before="Manage leads across"
              highlight="all insurance types"
              text="Specialized workflows for every insurance product you sell."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8"
            >
              {INSURANCE_TYPES.map((t) => (
                <motion.li key={t.title} variants={item} className={`${CARD} flex items-center gap-4 p-6`}>
                  <div className={ACCENT_BAR} />
                  <IconTile icon={t.icon} size="lg" />
                  <div className="min-w-0">
                    <h3 className="text-lg font-medium tracking-tight text-[#28194f]">{t.title}</h3>
                    <p className="mt-1 text-sm leading-snug text-slate-600">{t.desc}</p>
                  </div>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= WHO IT'S FOR ================= */}
        <section
          id="insurance-audience"
          aria-labelledby="insurance-audience-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="insurance-audience-heading"
              pill="Who It's For"
              icon={Users}
              before="Built for every"
              highlight="insurance sales team"
              text="From large insurers to individual agents, LMSBOTS adapts to how your team finds and keeps policyholders."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
            >
              {AUDIENCE.map((a) => (
                <motion.li key={a.title} variants={item} className={`${CARD} p-6`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-4">
                    <IconTile icon={a.icon} />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{a.title}</h3>
                  <p className="text-sm leading-[1.7] text-slate-700">{a.desc}</p>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= WORKFLOW ================= */}
        <section
          id="insurance-workflow"
          aria-labelledby="insurance-workflow-heading"
          className="relative isolate w-full overflow-hidden border-t border-[#48247f]/10 bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
        >
          <div className="pointer-events-none absolute -bottom-24 -left-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="insurance-workflow-heading"
              pill="Lead Management Workflow"
              icon={RefreshCw}
              before="From"
              highlight="lead to policyholder"
              after="in 4 simple steps"
              text="Automated workflows that guide prospects through your insurance sales pipeline."
            />

            <motion.ol
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 lg:gap-6"
            >
              {WORKFLOWS.map((w, i) => (
                <motion.li key={w.title} variants={item} className={`${CARD} h-full p-6`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-5 flex items-start justify-between">
                    <IconTile icon={w.icon} />
                    <span className="text-3xl font-light leading-none text-[#48247f]/15 transition-colors duration-300 group-hover:text-[#12dfbd]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="mb-4 text-lg font-medium tracking-tight text-[#28194f]">{w.title}</h3>
                  <ul className="space-y-2.5">
                    {w.steps.map((s) => (
                      <li key={s} className="flex items-start gap-2.5 text-sm text-slate-700">
                        <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#0f9d86]" strokeWidth={2.5} />
                        <span>{s}</span>
                      </li>
                    ))}
                  </ul>
                </motion.li>
              ))}
            </motion.ol>
          </div>
        </section>

        {/* ================= BENEFITS ================= */}
        <section
          id="insurance-benefits"
          aria-labelledby="insurance-benefits-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="insurance-benefits-heading"
              pill="Key Benefits"
              icon={TrendingUp}
              before="Why insurance companies choose"
              highlight="LMSBOTS"
              text="Close more policies faster with intelligent automation and real-time insight."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
            >
              {BENEFITS.map((b) => (
                <motion.li key={b.title} variants={item} className={`${CARD} p-6`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-4">
                    <IconTile icon={b.icon} />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{b.title}</h3>
                  <p className="text-sm leading-[1.7] text-slate-700">{b.desc}</p>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= CORE FEATURES ================= */}
        <section
          id="insurance-core"
          aria-labelledby="insurance-core-heading"
          className="relative isolate w-full overflow-hidden bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
        >
          <div className="pointer-events-none absolute -left-24 -top-24 -z-10 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="insurance-core-heading"
              pill="Core Capabilities"
              before="Powerful features for"
              highlight="insurance success"
              text="Everything you need to streamline lead management and close more policies."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8"
            >
              {CORE_FEATURES.map((f) => (
                <motion.li key={f.title} variants={item} className={`${CARD} p-6 sm:p-7`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-4">
                    <IconTile icon={f.icon} />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{f.title}</h3>
                  <p className="text-sm leading-[1.7] text-slate-700">{f.desc}</p>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= LEAD JOURNEY ================= */}
        <section
          id="insurance-journey"
          aria-labelledby="insurance-journey-heading"
          className="relative w-full overflow-hidden bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="insurance-journey-heading"
              pill="Lead Journey"
              before="The complete"
              highlight="insurance lead journey"
              text="See how leads move through your automated sales pipeline, from first inquiry to policy activation and renewal."
            />
          </div>

          <div className="ins-pause relative space-y-4" role="group" aria-label="Examples of stages in the insurance lead journey">
            <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-white to-transparent sm:w-32" />
            <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-white to-transparent sm:w-32" />

            {[
              { list: JOURNEY_1, dir: "ins-left" },
              { list: JOURNEY_2, dir: "ins-right" },
            ].map(({ list, dir }) => (
              <div key={dir} className="overflow-hidden">
                <ul className={`ins-track ${dir}`}>
                  {list.map((j) => (
                    <JourneyChip key={j.label} {...j} />
                  ))}
                  {/* Duplicate set makes the loop seamless; hidden from assistive tech and reduced-motion users */}
                  {list.map((j) => (
                    <JourneyChip key={`dup-${j.label}`} dup {...j} />
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <p className="mx-auto mt-10 max-w-3xl px-4 text-center text-[15px] leading-[1.75] text-[#3b2a63] sm:px-10 sm:text-base">
            Automate your insurance sales pipeline from lead capture and scoring to quoting,
            application follow-up, and renewal, with complete visibility into every stage.
          </p>
        </section>

        {/* ================= FAQ ================= */}
        <section
          id="insurance-faq"
          aria-labelledby="insurance-faq-heading"
          className="relative isolate w-full overflow-hidden bg-gradient-to-br from-[#fbf7ff] via-white to-[#effbf8] py-14 sm:py-16 lg:py-24"
        >
          <div className="pointer-events-none absolute -bottom-24 -right-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
          <div className="mx-auto w-full max-w-[900px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="insurance-faq-heading"
              pill="FAQ"
              before="Insurance lead management"
              highlight="questions answered"
            />

            <div className="space-y-4">
              {FAQS.map(({ q, a }, i) => (
                <details
                  key={q}
                  open={i === 0}
                  className="group overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white shadow-[0_8px_30px_-14px_rgba(72,36,127,0.25)] transition-colors open:border-[#702cb0]/40"
                >
                  <summary className="flex min-h-[64px] cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#702cb0] sm:px-6 [&::-webkit-details-marker]:hidden">
                    <h3 className="flex-1 text-[15px] font-medium leading-snug text-[#28194f] sm:text-base">{q}</h3>
                    <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-open:rotate-180 group-open:bg-[#12dfbd] group-open:text-[#102b37]">
                      <ChevronDown className="h-5 w-5" />
                    </span>
                  </summary>
                  <p className="px-5 pb-6 text-sm leading-[1.75] text-slate-700 sm:px-6 sm:text-[15px]">{a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* ================= CLOSING CTA ================= */}
        <section
          aria-labelledby="insurance-cta-heading"
          className="w-full bg-white px-4 py-10 sm:px-10 sm:py-12 lg:px-14 lg:py-16"
        >
          <div className="relative isolate mx-auto w-full max-w-[1300px] overflow-hidden rounded-[1.5rem] border border-[#48247f]/10 bg-gradient-to-br from-[#e3faf5] via-white to-[#f1ecfa] px-5 py-12 text-center shadow-[0_20px_60px_-20px_rgba(72,36,127,0.25)] sm:rounded-[2rem] sm:px-12 sm:py-16">
            <div className="pointer-events-none absolute -left-20 -top-20 -z-10 h-72 w-72 rounded-full bg-[#702cb0]/10 blur-3xl" />
            <h2
              id="insurance-cta-heading"
              className="mx-auto max-w-2xl text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px]"
            >
              Ready to convert{" "}
              <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
                more policies?
              </span>
            </h2>
            <p className="mx-auto mt-4 max-w-[560px] text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base">
              See how LMSBOTS fits your insurance sales process. In a live demo we'll cover lead
              capture, quotes, agent assignment, renewals, and reporting.
            </p>
            <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
              <Link
                to="/contact"
                className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-7 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
              >
                Request a Demo
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <Link
                to="/pricing"
                className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-7 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
              >
                View Pricing
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Insurance;